import React from 'react';
export function HeroBackground() {
  return <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true" data-id="element-104">
      <svg className="absolute w-full h-full" viewBox="0 0 1200 800" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-105">
        {/* Large geometric rectangles with hard edges */}
        <rect x="800" y="-100" width="500" height="500" fill="url(#gradient1)" opacity="0.08" transform="rotate(25 1050 150)" data-id="element-106" />

        <rect x="-50" y="400" width="400" height="400" fill="url(#gradient2)" opacity="0.06" transform="rotate(-15 150 600)" data-id="element-107" />

        {/* Medium rectangles */}
        <rect x="700" y="350" width="250" height="250" fill="url(#gradient3)" opacity="0.1" transform="rotate(35 825 475)" data-id="element-108" />

        <rect x="200" y="50" width="180" height="180" fill="url(#gradient4)" opacity="0.07" transform="rotate(-25 290 140)" data-id="element-109" />

        {/* Small accent squares */}
        <rect x="950" y="550" width="120" height="120" fill="hsl(var(--brand-gold))" opacity="0.08" transform="rotate(45 1010 610)" data-id="element-110" />

        <rect x="100" y="200" width="100" height="100" fill="hsl(var(--brand-blue-light))" opacity="0.06" transform="rotate(20 150 250)" data-id="element-111" />

        {/* Abstract lines */}
        <path d="M 0 400 Q 300 350 600 400 T 1200 400" stroke="url(#lineGradient1)" strokeWidth="2" fill="none" opacity="0.12" data-id="element-112" />

        <path d="M 0 500 Q 400 450 800 500 T 1200 500" stroke="url(#lineGradient2)" strokeWidth="2" fill="none" opacity="0.08" data-id="element-113" />

        {/* Gradients */}
        <defs data-id="element-114">
          <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-115">
            <stop offset="0%" stopColor="hsl(var(--brand-blue-light))" data-id="element-116" />
            <stop offset="100%" stopColor="hsl(var(--brand-blue-dark))" data-id="element-117" />
          </linearGradient>

          <linearGradient id="gradient2" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-118">
            <stop offset="0%" stopColor="hsl(var(--brand-gold))" data-id="element-119" />
            <stop offset="100%" stopColor="hsl(var(--brand-blue-light))" data-id="element-120" />
          </linearGradient>

          <linearGradient id="gradient3" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-121">
            <stop offset="0%" stopColor="hsl(var(--brand-blue-dark))" data-id="element-122" />
            <stop offset="100%" stopColor="hsl(var(--brand-blue-light))" data-id="element-123" />
          </linearGradient>

          <linearGradient id="gradient4" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-124">
            <stop offset="0%" stopColor="hsl(var(--brand-blue-light))" data-id="element-125" />
            <stop offset="100%" stopColor="hsl(var(--brand-gold))" data-id="element-126" />
          </linearGradient>

          <linearGradient id="lineGradient1" x1="0%" y1="0%" x2="100%" y2="0%" data-id="element-127">
            <stop offset="0%" stopColor="hsl(var(--brand-blue-light))" stopOpacity="0" data-id="element-128" />
            <stop offset="50%" stopColor="hsl(var(--brand-blue-light))" stopOpacity="1" data-id="element-129" />
            <stop offset="100%" stopColor="hsl(var(--brand-blue-light))" stopOpacity="0" data-id="element-130" />
          </linearGradient>

          <linearGradient id="lineGradient2" x1="0%" y1="0%" x2="100%" y2="0%" data-id="element-131">
            <stop offset="0%" stopColor="hsl(var(--brand-gold))" stopOpacity="0" data-id="element-132" />
            <stop offset="50%" stopColor="hsl(var(--brand-gold))" stopOpacity="1" data-id="element-133" />
            <stop offset="100%" stopColor="hsl(var(--brand-gold))" stopOpacity="0" data-id="element-134" />
          </linearGradient>
        </defs>
      </svg>
    </div>;
}